import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import OrderFormWizard from '../components/orderformwizard';
import { submitOrderWizard, toggleOrderSummary } from '../actions';
import { profileSelector } from '../selector';

const mapStateToProps = state => ({
  ...profileSelector(state),
});

const mapDispatchToProps = dispatch => ({
  submitWizard: values => dispatch(submitOrderWizard(values)),
  toggleOrderSummary: () => dispatch(toggleOrderSummary()),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(OrderFormWizard);



// WEBPACK FOOTER //
// ../shop_main/containers/wizard.js